import { render, staticRenderFns } from "./Reserves.vue?vue&type=template&id=34b43c9a&scoped=true"
import script from "./Reserves.vue?vue&type=script&lang=js"
export * from "./Reserves.vue?vue&type=script&lang=js"
import style0 from "./Reserves.vue?vue&type=style&index=0&id=34b43c9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b43c9a",
  null
  
)

export default component.exports